import { BaseModel } from './base-model.interface';
import BlockModel from './block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface ReviewsModel extends BaseModel {
  variables?: { [key: string]: string } | ReviewsVariables;
}

export interface ReviewsVariables {
  ReviewsImage: string;
  ReviewsImageHref: string;
  ReviewsImageAlt: string;
  ReviewsPropertyName: string;
  ReviewsText: string;
  ReviewsImageHrefSegmentRegex: string;
}

export class ReviewsInitVariables implements ReviewsVariables {
  ReviewsImage = '';
  ReviewsImageHref = '';
  ReviewsImageAlt = '';
  ReviewsPropertyName = '';
  ReviewsText = '';
  ReviewsImageHrefSegmentRegex = '';
}

export class ReviewsInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new ReviewsInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
